module.exports = __webpack_public_path__ + "img/info-item-2.58fe7f1a.png";